import React, {useState, Fragment, useEffect} from 'react';
import RegisterBankDetails from './../register/RegisterBankDetails';
import NewUserRegistration from './../register/NewUserRegistration';
import * as RegistrationService from './../../services/RegistrationService';
import ProfileModal from './ProfileModal';
import _ from 'lodash';

export default function ProfileSettingsPage() {
  const [updateDetails, setUpdateDetails] = useState({
    showModal: false,
    type: null,
    title: null,
    details: null
  });
  const [showProfileModal, setShowProfileModal] = useState(true);

  const fetchBankDetails = async () => {
    const response = await RegistrationService.getBankDetails();
    if (!response.error) {
      updateDetails.details = response.data;
      setUpdateDetails({...updateDetails});
    }
  };

  async function updateBankDetailsHandler(params) {
    const response = await RegistrationService.updateBankDetails(params);
    console.log('response:', response);
    if (!response.error) {
      setUpdateDetails({showModal: false,
        type: null,
        title: null,
        details: null});
    }
  }

  useEffect(() => {
    console.log('useEffect updateDetails:', updateDetails);
    if (updateDetails.showModal && _.isEmpty(updateDetails.details)) {
      if (updateDetails.type === 'Bank Account') {
        fetchBankDetails();
      }
    }
  }, [updateDetails]);

  console.log('updateDetails:', updateDetails);

  const modalToggleHandler = () => {
    setUpdateDetails({
      showModal: false,
      type: null,
      title: null,
      details: null
    });
  };
  const componentFactory = (componentType, componentData) => {
    let renderComponent = null;
    switch (componentType) {
      case "My Account":
        renderComponent = <NewUserRegistration />;
        break;
      case "Bank Account":
        renderComponent = (
          <RegisterBankDetails
            updateBankDetailsHandler={updateBankDetailsHandler}
            bankDetails={componentData}
          />
        );
        break;

      default:
        break;
    }

    return renderComponent;
  };

  return (
    <>
      {updateDetails.showModal && (
        <ProfileModal
          openModal={updateDetails.showModal}
          modalTitle={updateDetails.title}
          modalToggleHandler={modalToggleHandler}
        >
          {componentFactory(updateDetails.type, updateDetails.details)}
        </ProfileModal>
      )}
      <div className="py-3">
        <h4>{'Profile Settings'}</h4>
        <div className="row py-3">
          <div className="col col-4 cursor-pointer">
            <div
              className="card"
              onClick={() => {
                setUpdateDetails({
                  showModal: true,
                  type: 'My Account',
                  title: 'Update My Account',
                  details: null
                });
              }}
            >
              <div className="card-body">{'My Account'}</div>
            </div>
          </div>
          <div className="col col-4 cursor-pointer">
            <div
              className="card"
              onClick={() => {
                setUpdateDetails({
                  showModal: true,
                  type: 'Bank Account',
                  title: 'Update Bank Account',
                  details: null
                });
              }}
            >
              <div className="card-body">{'Bank Account'}</div>
            </div>
          </div>
          <div className="col col-4 cursor-pointer">
            <div className="card">
              <div className="card-body">{'SignOut'}</div>
            </div>
          </div>
          {/* <div className="col col-4 cursor-pointer">
            <RegisterBankDetails bankDetails={bankDetails} updateBankDetailsHandler={() => {}} />
          </div> */}
        </div>
      </div>
    </>
  );
}
